
import axios from '../axios'
import Vue from 'vue'
// 获取课程列表
export const getCourseList = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/course',
    method: 'get',
    params: data
  })
}



// 获取课程列表
export const searchCourse = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/coursesearch',
    method: 'get',
    params: data
  })
}
// 获取课程名称ById
export const getCourseName = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/coursename',
    method: 'get',
    params: data
  })
}
// 添加课程
export const addCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/course',
    method: 'post',
    data
  })
}

// 修改课程
export const modifyCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/course',
    method: 'patch',
    data
  })
}

// 删除课程
export const delCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/course',
    method: 'delete',
    data
  })
}

// 获取直播，根据课程ID
export const getLiveByCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/live',
    method: 'get',
    params: data
  })
}

// 获取主教室直播，根据课程ID
export const getMasetLiveByCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/masterlive',
    method: 'get',
    params: data
  })
}

// 获取子教室直播，根据课程ID，主教室
export const getSubLiveByCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/sublive',
    method: 'get',
    params: data
  })
}

// 搜索主教室直播，根据课程ID
export const searchMasetLiveByCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/masterlivesearch',
    method: 'get',
    params: data
  })
}

// 获取直播信息，根据直播ID
export const getLiveInfoById = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/liveiteminfo',
    method: 'get',
    params: data
  })
}

// 获取所有直播
export const getAllLive = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/alllive',
    method: 'get',
    params: data
  })
}
// 获取课程列表
export const getSearchLiveList = (data) => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/livesearch',
    method: 'get',
    params: data
  })
}
// 添加直播
export const addLive = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/live',
    method: 'post',
    data
  })
}

// 修改直播
export const modifyLive = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/live',
    method: 'patch',
    data
  })
}

// 作废直播
export const deleteLive = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/live',
    method: 'delete',
    data
  })
}


// 给直播添加学生
export const addStuToLive = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentlive',
    method: 'post',
    data
  })
}
// 给直播删除学生
export const delStuToLive = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentlive',
    method: 'delete',
    data
  })
}
// 获取该直播已添加的学生
export const getAddedStuByLive = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentlive',
    method: 'get',
    params: data
  })
}
// 获取该直播已添加的学生搜索
export const getAddedStuBySearchLive = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentlivesearch',
    method: 'get',
    params: data
  })
}
// 获取未添加进直播的学生
export const getUnAddedStuByLive = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentunlive',
    method: 'get',
    params: data
  })
}
// 获取未添加进直播的学生搜索
export const getUnAddedStuBySearchLive = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentunlivesearch',
    method: 'get',
    params: data
  })
}
// 给课程添加学生
export const addStuToCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentcourse',
    method: 'post',
    data
  })
}
// 给课程删除学生
export const delStuToCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentcourse',
    method: 'delete',
    data
  })
}

// 获取该课程已添加的学生
export const getAddedStuByCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentcourse',
    method: 'get',
    params: data
  })
}

// 获取该课程已添加的学生搜索
export const getAddedStuBySearchCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentcoursesearch',
    method: 'get',
    params: data
  })
}

// 获取未添加进课程的学生
export const getUnAddedStuByCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentuncourse',
    method: 'get',
    params: data
  })
}
// 获取未添加进课程的学生搜索
export const getUnAddedStuBySearchCourse = data => {
  return axios({
    url: Vue.prototype.baseServer.cmsServer + '/cms/studentcourseunaddsearch',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/courseManager.js